import { Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export type TColorName =
  | 'successMain'
  | 'warningDark'
  | 'errorMain'
  | 'extreme'
  | 'textDisabled'
  | 'verifiedIdentity'
  | 'rejectedIdentity'
  | 'draftIdentity'
  | 'unverifiedIdentity'
  | 'infoDark'
  | 'actionActive'
  | 'verificationPending';
export type TIconName =
  | 'checkCircle'
  | 'block'
  | 'remove'
  | 'pending'
  | 'closeFullscreenRounded'
  | 'checkCircleRounded'
  | 'warningRounded'
  | 'cancelRounded'
  | 'blockRounded'
  | 'radioButtonUncheckedRounded'
  | 'removeCircleRounded'
  | 'errorRounded'
  | 'keyboardArrowDownRounded'
  | 'deleteRounded'
  | 'warningAmberRounded'
  | 'addRounded'
  | 'closeRounded'
  | 'editRounded'
  | 'verifiedRounded'
  | 'arrowRightRounded'
  | 'arrowLeftRounded'
  | 'LockRounded'
  | 'emailRounded'
  | 'moreVertRounded'
  | 'autoAwesomeRounded'
  | 'reviewsRounded'
  | 'fileCopyRounded'
  | 'uploadFileIcon'
  | 'imageNotSupportedRounded'
  | 'openInNewRounded'
  | 'pdfRounded'
  | 'replayRounded'
  | 'infoRounded'
  | 'fileDownloadRounded'
  | 'checkRounded';

export const COLOR_MAPPING: {
  [colorName in TColorName]: (theme: Theme) => {
    textColor: string;
    fillColor?: string;
    borderColor?: string;
    iconColor?: string;
  };
} = {
  successMain: (theme: Theme) => ({
    textColor: theme.palette.success.contrastText,
    fillColor: theme.palette.success.main,
    iconColor: theme.palette.success.contrastText,
  }),
  warningDark: (theme: Theme) => ({
    textColor: theme.palette.warning.contrastText,
    fillColor: theme.palette.warning.dark,
    iconColor: theme.palette.warning.contrastText,
  }),
  errorMain: (theme: Theme) => ({
    textColor: theme.palette.error.contrastText,
    fillColor: theme.palette.error.main,
    iconColor: theme.palette.success.contrastText,
  }),
  extreme: (theme: Theme) => ({
    textColor: theme.palette.error.contrastText,
    fillColor: theme.palette.grey[800],
    borderColor: theme.palette.text.primary,
    iconColor: theme.palette.success.contrastText,
  }),
  textDisabled: (theme: Theme) => ({
    textColor: theme.palette.error.contrastText,
    fillColor: theme.palette.text.disabled,
    iconColor: theme.palette.success.contrastText,
  }),
  verifiedIdentity: (theme: Theme) => ({
    textColor: theme.palette.success.contrastText,
    fillColor: theme.palette.success.main,
    iconColor: theme.palette.success.contrastText,
  }),
  rejectedIdentity: (theme: Theme) => ({
    textColor: theme.palette.error.contrastText,
    fillColor: theme.palette.error.main,
    iconColor: theme.palette.success.contrastText,
  }),
  draftIdentity: (theme: Theme) => ({
    textColor: theme.palette.error.contrastText,
    fillColor: theme.palette.text.disabled,
    iconColor: alpha(theme.palette.success.contrastText, 0.5),
  }),
  unverifiedIdentity: (theme: Theme) => ({
    textColor: theme.palette.error.contrastText,
    fillColor: theme.palette.text.disabled,
    iconColor: theme.palette.success.contrastText,
  }),
  infoDark: (theme: Theme) => ({
    textColor: theme.palette.info.dark,
    borderColor: theme.palette.info.dark,
  }),
  actionActive: (theme: Theme) => ({
    textColor: theme.palette.action.active,
    fillColor: theme.palette.action.active,
    iconColor: alpha(theme.palette.action.active, 0.5),
  }),
  verificationPending: (theme: Theme) => ({
    textColor: theme.palette.text.disabled,
    fillColor: theme.palette.background.paper,
    borderColor: theme.palette.action.disabled,
    iconColor: alpha(theme.palette.success.contrastText, 0.5),
  }),
};

export function getColorByName(colorName: TColorName) {
  return COLOR_MAPPING[colorName];
}
